import React, { useMemo } from "react";
import { DataTable } from "../../../../../components/table/data-table";
import type { DataTablePagination } from "../../../../../components/table/data-table";
import { MerchantCouponListFilter, MerchantCouponListUIState } from "../../data/merchantCouponList.data";
import { createMerchantCouponListColumns } from "./merchantCouponListColumns";

interface MerchantCouponListTableProps {
  coupons: MerchantCouponListUIState[];
  loading?: boolean;
  error?: React.ReactNode;
  filters?: MerchantCouponListFilter;
  updateFilter?: (filter: Partial<MerchantCouponListFilter>) => void;
  pagination?: DataTablePagination;
  onRetry?: () => void;
  onEdit?: (coupon: MerchantCouponListUIState) => void;
  onDelete?: (coupon: MerchantCouponListUIState) => void;
  onRestock?: (coupon: MerchantCouponListUIState) => void;
  onCopy?: (coupon: MerchantCouponListUIState) => void;
}

export const MerchantCouponListTable: React.FC<MerchantCouponListTableProps> = ({ coupons, loading = false, error, filters = {}, updateFilter, pagination, onRetry, onEdit, onDelete, onRestock, onCopy }) => {
  const columns = useMemo(
    () => createMerchantCouponListColumns({ filters, updateFilter: updateFilter ?? (() => undefined), onEdit, onDelete, onRestock, onCopy }),
    [filters, onCopy, onDelete, onEdit, onRestock, updateFilter],
  );

  return <DataTable columns={columns} dataSource={coupons} rowKey="id" loading={loading} error={error} onRetry={onRetry} emptyLabel="No coupons found" pagination={pagination} containerClassName="w-full" tableClassName="min-w-[1500px]" />;
};
